import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  PRINT_CREATE_REQUESTED,
  PRINT_CREATE_SUCCESS,
  PRINT_CREATE_FAILURE,
} from '../types';

export const printCreateRequested = () => {
  return {
    type: PRINT_CREATE_REQUESTED
  }
};

export const printCreateSuccess = (downloadUrl) => {
  return {
    type: PRINT_CREATE_SUCCESS,
    payload: downloadUrl
  }
};

export const printCreateFailure = (error) => {
  return {
    type: PRINT_CREATE_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};

export const requestPrint = (shopUrl, signedPayload, template, printCounts, printOrder) => {
  return (dispatch) => {
    dispatch(printCreateRequested());

    let endPoint = Config.baseUrl + Config.print;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;
    headers.shop = shopUrl;

    return Axios.post(endPoint, { template_uuid: template, counts: printCounts, order: printOrder } , { headers: headers })
      .then((response) => {
        dispatch(printCreateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(printCreateFailure(error));
      });
  }
}
